// Share simultaneous reads only; settled business data is never retained here.
export function coalesceReads(adapter, getUri) {
  const pending = new Map();
  let revision = 0;
  return async (config) => {
    if (String(config.method || "get").toLowerCase() !== "get") {
      revision += 1;
      pending.clear();
      try {
        return await adapter(config);
      } finally {
        revision += 1;
        pending.clear();
      }
    }
    if (config.signal || config.cancelToken || config.responseType === "blob" ||
        config.responseType === "arraybuffer" || config.deduplicate === false) {
      return adapter(config);
    }
    const key = JSON.stringify([
      revision, getUri(config), config.headers, config.timeout,
      config.responseType, config.withCredentials,
    ]);
    let request = pending.get(key);
    if (!request) {
      request = Promise.resolve().then(() => adapter(config));
      pending.set(key, request);
    }
    try {
      const response = await request;
      return {
        ...response, config,
        data: response.data && typeof response.data === "object"
          ? JSON.parse(JSON.stringify(response.data)) : response.data,
      };
    } catch (error) {
      throw Object.assign(Object.create(Object.getPrototypeOf(error)), error, { config });
    } finally {
      if (pending.get(key) === request) pending.delete(key);
    }
  };
}
